<template>
  <div class="wrapper">
    <img class="cover" src="@/assets/logo.png" alt="" />
    <span class="title hidden md:flex">MuleEx</span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 5px;
}

.cover {
  height: 30px;
  display: block;
}

.title {
  font-weight: 600;
  font-size: 28px;
}
</style>
